// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/SFPRODISPLAYREGULAR.OTF", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'SF Pro Display';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

/* SFProDisplay-Regular.ttf */

.dashboard_calenderstyle__J11yM{
    border: 1px solid gray;
    padding: 3px;
    border-radius: 10px;
    color: black;
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: bold;
}

.dashboard_colourCode__BXkqH{
    width: 20px;
    height: 20px;
    background-color: rebeccapurple;
}

.dashboard_colourCode__BXkqH ~ p {
    color: black;
    font-weight: bold;
}

.dashboard_mobile_dashboard__WPstT {
    min-height: 80vh;
}

.dashboard_mobile_dashboard__WPstT .dashboard_heading__spUTn {
    /* background-color: white; */
    /* color was text-grey-800  */
    color: grey;
    padding-top: 10px;
}

.dashboard_count__nJN3A {
    color: #0094ff;
    /* color was text-grey-800  */
    color: grey
}

.dashboard_iconColor__xbtwS i {
    /* color was text-grey-300  */
    color: grey
}


.dashboard_mobile_dashboard__WPstT .dashboard_heading__spUTn span {
    display: none;
}


.dashboard_icn__2aw60::before {
    content: "\\f155";
}

.dashboard_perforamanceFlow__hGGU7 {
    display: none;
}

.dashboard_doropdownnavmenu__0I7xI {
    display: flex;
    flex-direction: column;
}



.dashboard_iconColor__xbtwS img {
    /* color was text-grey-300  */
    width: 90%;
    animation-name: dashboard_floatingIcons__2S4Ff;
    animation-duration: 1s;
}

@keyframes dashboard_floatingIcons__2S4Ff {
    0% {
        transform: translate(-220px) scale(0);
        /* transform: scale(0); */
        opacity: 0;
    }

    100% {
        transform: translate(0px) scale(1);
        /* transform: scale(1); */
        opacity: 1;
    }
}

.dashboard_lineGraphMain__DUvfQ {
    width: 50%;
    border-radius: 20px;
    border: 1px solid black !important;
    box-shadow: 1px 1px 12px grey;
}
.dashboard_lineGraph__uG35H{
    width: 50%;
    border-radius: 20px;
    border: 1px solid black !important;
    box-shadow: 1px 1px 12px grey;
    height: 371px;
    
}



.dashboard_mobileBoxes__7j4vZ{
    width: 45%;
    box-shadow: grey 1px 1px 6px 1px;
    border: 1px solid grey;
    border-radius: 10px;
    background: white;
}

.dashboard_mobileBoxes__7j4vZ p{
    margin-bottom: 0 ;
}

.dashboard_mobileBoxes__7j4vZ .dashboard_counti__m\\+PRe {
    font-size: 29px;
    color: black;
    font-weight: bold;
    /* margin: 0.25rem 0rem; */
}

.dashboard_showOnMobile__Clkgx{
    display: none;
}
.dashboard_showOnDesktop__OmbLT{
    display: block;
}

.dashboard_spinnerBox__b9rkN{
    transform: rotate(46deg);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 125px;
    height: 125px;
    border-radius: 50%;
}
.dashboard_spinnerBox__b9rkN p{
    transform: rotate(-47deg);
    font-size: 15px;
    font-weight: bold;
}
.dashboard_spinnerBox2__N\\+hNW{
    width: 125px;
    height: 125px;
    border-radius: 50%;
    border-width: 15px 16px 16px;
    border-style: solid;
    border-color: blue rgb(243, 243, 243) rgb(243, 243, 243);
    border-image: initial;
}

.dashboard_graphHeading__WgH3v{
    font-size: 18px;
    color: black !important;
    font-weight: 600 !important;
}
.dashboard_cardHeading__yWWU9{
    color: black;
    font-weight: 600;
}
.dashboard_graphMain__MepwA{
    gap:20px;
    /* border: 1px solid red; */
}

.dashboard_orderBreakdowntexts__xwpDh{
    font-size: 16px;
    color: rgb(32, 32, 32);
  
}

.dashboard_orderBreakdowntexts__xwpDh ~ p{
    font-size: 19px;
    color: black;
    font-weight: 600;
}
@media screen and (max-width: 1030px){
    .dashboard_graphMain__MepwA {
        flex-direction: column;
    }

    .dashboard_lineGraphMain__DUvfQ {
        width: 100%;
       
    }
}

@media screen and (max-width: 768px) {
    .dashboard_mobile_dashboard__WPstT {
        min-height: auto;
    }

    .dashboard_mobile_dashboard__WPstT .dashboard_heading__spUTn h1 {
        color: #0094ff;
        font-weight: 500;
        font-size: 22px;
        line-height: 27px;
        font-family: 'SF Pro Display';
    }

    .dashboard_mobile_dashboard__WPstT .dashboard_heading__spUTn span {
        display: block;
        color: black;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        font-family: 'SF Pro Display';
        letter-spacing: 2px;

    }

    .dashboard_count__nJN3A {
        color: #2392FF;
        font-weight: 700;
        font-size: 32px;
        line-height: 38.19px;
        padding-top: 20px;
        padding-bottom: 10px;
    }


    .dashboard_cardHeading__yWWU9 {
        color: black;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
    }

    .dashboard_cardSttyle__JwJfm {
        border: none !important;
        border-radius: 20px;
        padding-left: 14px;
        padding-right: 14px;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }

    .dashboard_cardSttyle__JwJfm>div {
        padding: 0;
        padding-top: 11px;
    }

    .dashboard_perforamanceFlow__hGGU7 {
        display: block;
        color: grey;
        font-family: 'SF Pro Display';
        font-size: 16px;
    }

    .dashboard_graphMain__MepwA {
        flex-direction: column;
    }

    .dashboard_lineGraphMain__DUvfQ {
        width: 100%;
    }

    .dashboard_graphHeading__WgH3v{
        font-size: 12px;
        color: black !important;
        font-weight: 500 !important;
    }




}

@media screen and (max-width: 430px) {
    .dashboard_showOnMobile__Clkgx{
        display: block;
    }

    .dashboard_showOnDesktop__OmbLT{
        display: none;
    }
    
}
@media screen and (max-width: 330px) {
    .dashboard_iconColor__xbtwS i {
        /* color was text-grey-300  */
        color: #2392FF;
        font-size: 50px
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/dashboard.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,+DAAkE;IAClE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,6BAA6B;;AAE7B;IACI,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;;AAGA;IACI,aAAa;AACjB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;;;AAIA;IACI,6BAA6B;IAC7B,UAAU;IACV,8CAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI;QACI,qCAAqC;QACrC,yBAAyB;QACzB,UAAU;IACd;;IAEA;QACI,kCAAkC;QAClC,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kCAAkC;IAClC,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,kCAAkC;IAClC,6BAA6B;IAC7B,aAAa;;AAEjB;;;;AAIA;IACI,UAAU;IACV,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,wDAAwD;IACxD,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,sBAAsB;;AAE1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;;IAEf;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,6BAA6B;QAC7B,mBAAmB;;IAEvB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,iBAAiB;QACjB,oBAAoB;IACxB;;;IAGA;QACI,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,6BAA6B;QAC7B,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,2BAA2B;IAC/B;;;;;AAKJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;AAEJ;AACA;IACI;QACI,6BAA6B;QAC7B,cAAc;QACd;IACJ;AACJ","sourcesContent":["@font-face {\n    font-family: 'SF Pro Display';\n    src: url('../../fonts/SFPRODISPLAYREGULAR.OTF') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n/* SFProDisplay-Regular.ttf */\n\n.calenderstyle{\n    border: 1px solid gray;\n    padding: 3px;\n    border-radius: 10px;\n    color: black;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-weight: bold;\n}\n\n.colourCode{\n    width: 20px;\n    height: 20px;\n    background-color: rebeccapurple;\n}\n\n.colourCode ~ p {\n    color: black;\n    font-weight: bold;\n}\n\n.mobile_dashboard {\n    min-height: 80vh;\n}\n\n.mobile_dashboard .heading {\n    /* background-color: white; */\n    /* color was text-grey-800  */\n    color: grey;\n    padding-top: 10px;\n}\n\n.count {\n    color: #0094ff;\n    /* color was text-grey-800  */\n    color: grey\n}\n\n.iconColor i {\n    /* color was text-grey-300  */\n    color: grey\n}\n\n\n.mobile_dashboard .heading span {\n    display: none;\n}\n\n\n.icn::before {\n    content: \"\\f155\";\n}\n\n.perforamanceFlow {\n    display: none;\n}\n\n.doropdownnavmenu {\n    display: flex;\n    flex-direction: column;\n}\n\n\n\n.iconColor img {\n    /* color was text-grey-300  */\n    width: 90%;\n    animation-name: floatingIcons;\n    animation-duration: 1s;\n}\n\n@keyframes floatingIcons {\n    0% {\n        transform: translate(-220px) scale(0);\n        /* transform: scale(0); */\n        opacity: 0;\n    }\n\n    100% {\n        transform: translate(0px) scale(1);\n        /* transform: scale(1); */\n        opacity: 1;\n    }\n}\n\n.lineGraphMain {\n    width: 50%;\n    border-radius: 20px;\n    border: 1px solid black !important;\n    box-shadow: 1px 1px 12px grey;\n}\n.lineGraph{\n    width: 50%;\n    border-radius: 20px;\n    border: 1px solid black !important;\n    box-shadow: 1px 1px 12px grey;\n    height: 371px;\n    \n}\n\n\n\n.mobileBoxes{\n    width: 45%;\n    box-shadow: grey 1px 1px 6px 1px;\n    border: 1px solid grey;\n    border-radius: 10px;\n    background: white;\n}\n\n.mobileBoxes p{\n    margin-bottom: 0 ;\n}\n\n.mobileBoxes .counti {\n    font-size: 29px;\n    color: black;\n    font-weight: bold;\n    /* margin: 0.25rem 0rem; */\n}\n\n.showOnMobile{\n    display: none;\n}\n.showOnDesktop{\n    display: block;\n}\n\n.spinnerBox{\n    transform: rotate(46deg);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 125px;\n    height: 125px;\n    border-radius: 50%;\n}\n.spinnerBox p{\n    transform: rotate(-47deg);\n    font-size: 15px;\n    font-weight: bold;\n}\n.spinnerBox2{\n    width: 125px;\n    height: 125px;\n    border-radius: 50%;\n    border-width: 15px 16px 16px;\n    border-style: solid;\n    border-color: blue rgb(243, 243, 243) rgb(243, 243, 243);\n    border-image: initial;\n}\n\n.graphHeading{\n    font-size: 18px;\n    color: black !important;\n    font-weight: 600 !important;\n}\n.cardHeading{\n    color: black;\n    font-weight: 600;\n}\n.graphMain{\n    gap:20px;\n    /* border: 1px solid red; */\n}\n\n.orderBreakdowntexts{\n    font-size: 16px;\n    color: rgb(32, 32, 32);\n  \n}\n\n.orderBreakdowntexts ~ p{\n    font-size: 19px;\n    color: black;\n    font-weight: 600;\n}\n@media screen and (max-width: 1030px){\n    .graphMain {\n        flex-direction: column;\n    }\n\n    .lineGraphMain {\n        width: 100%;\n       \n    }\n}\n\n@media screen and (max-width: 768px) {\n    .mobile_dashboard {\n        min-height: auto;\n    }\n\n    .mobile_dashboard .heading h1 {\n        color: #0094ff;\n        font-weight: 500;\n        font-size: 22px;\n        line-height: 27px;\n        font-family: 'SF Pro Display';\n    }\n\n    .mobile_dashboard .heading span {\n        display: block;\n        color: black;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n        font-family: 'SF Pro Display';\n        letter-spacing: 2px;\n\n    }\n\n    .count {\n        color: #2392FF;\n        font-weight: 700;\n        font-size: 32px;\n        line-height: 38.19px;\n        padding-top: 20px;\n        padding-bottom: 10px;\n    }\n\n\n    .cardHeading {\n        color: black;\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 16px;\n    }\n\n    .cardSttyle {\n        border: none !important;\n        border-radius: 20px;\n        padding-left: 14px;\n        padding-right: 14px;\n        padding-top: 0px !important;\n        padding-bottom: 0px !important;\n    }\n\n    .cardSttyle>div {\n        padding: 0;\n        padding-top: 11px;\n    }\n\n    .perforamanceFlow {\n        display: block;\n        color: grey;\n        font-family: 'SF Pro Display';\n        font-size: 16px;\n    }\n\n    .graphMain {\n        flex-direction: column;\n    }\n\n    .lineGraphMain {\n        width: 100%;\n    }\n\n    .graphHeading{\n        font-size: 12px;\n        color: black !important;\n        font-weight: 500 !important;\n    }\n\n\n\n\n}\n\n@media screen and (max-width: 430px) {\n    .showOnMobile{\n        display: block;\n    }\n\n    .showOnDesktop{\n        display: none;\n    }\n    \n}\n@media screen and (max-width: 330px) {\n    .iconColor i {\n        /* color was text-grey-300  */\n        color: #2392FF;\n        font-size: 50px\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calenderstyle": `dashboard_calenderstyle__J11yM`,
	"colourCode": `dashboard_colourCode__BXkqH`,
	"mobile_dashboard": `dashboard_mobile_dashboard__WPstT`,
	"heading": `dashboard_heading__spUTn`,
	"count": `dashboard_count__nJN3A`,
	"iconColor": `dashboard_iconColor__xbtwS`,
	"icn": `dashboard_icn__2aw60`,
	"perforamanceFlow": `dashboard_perforamanceFlow__hGGU7`,
	"doropdownnavmenu": `dashboard_doropdownnavmenu__0I7xI`,
	"floatingIcons": `dashboard_floatingIcons__2S4Ff`,
	"lineGraphMain": `dashboard_lineGraphMain__DUvfQ`,
	"lineGraph": `dashboard_lineGraph__uG35H`,
	"mobileBoxes": `dashboard_mobileBoxes__7j4vZ`,
	"counti": `dashboard_counti__m+PRe`,
	"showOnMobile": `dashboard_showOnMobile__Clkgx`,
	"showOnDesktop": `dashboard_showOnDesktop__OmbLT`,
	"spinnerBox": `dashboard_spinnerBox__b9rkN`,
	"spinnerBox2": `dashboard_spinnerBox2__N+hNW`,
	"graphHeading": `dashboard_graphHeading__WgH3v`,
	"cardHeading": `dashboard_cardHeading__yWWU9`,
	"graphMain": `dashboard_graphMain__MepwA`,
	"orderBreakdowntexts": `dashboard_orderBreakdowntexts__xwpDh`,
	"cardSttyle": `dashboard_cardSttyle__JwJfm`
};
export default ___CSS_LOADER_EXPORT___;
